import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Customer } from '../../../../../../../models/customer';
import { AccountService } from '../../../../../../../services/account/account.service';
import { CustomerService } from '../../../../../../../services/customer/customer.service';
import { DocumentTemplate, DocumentType } from '../../../../../../../models/document-template';
import { DocumentTemplateService } from '../../../../../../../services/document-template/document-template.service';
import { openClimberAppInNewTabAsCustomer, openClimberAppInNewTabAsStaff } from '../../../../../../../utils-models';
import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';

@Component({
  selector: 'app-open-document-for-customer-modal',
  templateUrl: './open-document-for-customer-modal.component.html',
  styleUrls: ['./open-document-for-customer-modal.component.css']
})
export class OpenDocumentForCustomerModalComponent implements OnInit {

  @Input() customer: Customer;

  public selectedDocumentTemplate: DocumentTemplate = null;

  public documentTemplateList: DocumentTemplate[];

  public loadingDocumentTemplates = false;
  public loadingSubmit = false;
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    private accountService: AccountService,
    private documentTemplateService: DocumentTemplateService,
    private orgService: OrganizationConfigService,
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  ngOnInit() {
    this.loadDocumentTemplates();
  }

  public handleSubmit() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.customerService
      .getCustomerClimberAppToken(this.customer.id)
      .then(token => {
        const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
        openClimberAppInNewTabAsCustomer(
          token,
          this.customer.id,
          baseUrl,
          this.selectedDocumentTemplate.climber_app_url
        );
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to fill out this document for this customer.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

  public isLoading() {
    return (this.loadingDocumentTemplates || this.loadingSubmit);
  }

  private loadDocumentTemplates() {
    this.loadingDocumentTemplates = true;

    this.documentTemplateService
      .getDocumentTemplates(1, 3000)
      .then(response => {
        this.documentTemplateList = response.results;
        this.documentTemplateList = this.documentTemplateList.sort(
          (a, b) => (a.name > b.name ? 1 : -1)
        );
        if (this.documentTemplateList.length > 0) {
          this.selectedDocumentTemplate = this.documentTemplateList[0];
        }
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingDocumentTemplates = false; });
  }

}
